// src/routes/AdminRoute.jsx
import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { tokenStore } from "../services/tokenStore";
import { decodeJwtRaw } from "../services/jwt";

const ROLE_CLAIM = "http://schemas.microsoft.com/ws/2008/06/identity/claims/role";

export default function AdminRoute({ children }) {
  const location = useLocation();

  // если есть слайс auth: { isLoggedIn, userRole, isLoading }
  const { isLoggedIn, userRole, isLoading } = useSelector((s) => s.auth || {});

  if (isLoading) return null; // или лоадер

  // роль берём из слайса, если нет — из токена в памяти
  let role = userRole;
  if (!role) {
    const token = tokenStore.get();
    if (!token) {
      return <Navigate to="/" replace state={{ from: location }} />;
    }
    try {
      const decoded = decodeJwtRaw(token);
      role = decoded?.[ROLE_CLAIM];
    } catch {
      return <Navigate to="/" replace state={{ from: location }} />;
    }
  }

  // проверяем логин (если есть флаг в слайсе) и роль
  if (isLoggedIn === false) {
    return <Navigate to="/" replace state={{ from: location }} />;
  }
  if (role !== "Admin") {
    return <Navigate to="/" replace />;
  }

  return children;
}
